import HomeView from './home_view';

export default HomeView;
